import { render, staticRenderFns } from "./Dropzone.vue?vue&type=template&id=00472d2b&scoped=true&"
import script from "./Dropzone.vue?vue&type=script&lang=js&"
export * from "./Dropzone.vue?vue&type=script&lang=js&"
import style0 from "./Dropzone.vue?vue&type=style&index=0&id=00472d2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00472d2b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VContainer,VIcon,VImg,VRow,VSheet})
